import ctl from "@netlify/classnames-template-literals";

export const card = ctl(`
  overflow-hidden
  transition-all
  duration-200
  w-full
  ease-in
`);
